<kendo-buttongroup [selection]="selectionMode$ | async" [fxLayout]="orientation$ | async" fxFill>
   <samweb-dynamic-action-button
      *ngFor="let entry of entries$ | async"
      kendoButton
      fxFlex="1 1 auto"
      class="sam-toggle-button"
      [actionEntry]="entry"
      [isTogglable]="toggleable$ | async"
      (dynamicActionClick)="dynamicActionClick($event)"
   ></samweb-dynamic-action-button>
</kendo-buttongroup>
